import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  inject,
} from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { ProfitabilityScoreSteps } from '@wilson/api/gateway';
import { AuthorizationModule } from '@wilson/authorization';
import { FeatureFlagsModule } from '@wilson/feature-flags';
import { ProfitabilityScoreState } from '@wilson/profitability-score/state';
import {
  SharedComponentsModule,
  UserDetailsModule,
} from '@wilson/shared-components';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { Observable } from 'rxjs';
import { ProfitabilityIconPipe } from '../../pipes/profitability-icon.pipe';

@Component({
  selector: 'wilson-user-timelines-profitability-score',
  templateUrl: './user-timelines-profitability-score.component.html',
  styleUrls: ['./user-timelines-profitability-score.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    SharedComponentsModule,
    NzTooltipModule,
    NzSkeletonModule,
    UserDetailsModule,
    AuthorizationModule,
    FeatureFlagsModule,
    TranslateModule,
    ProfitabilityIconPipe,
    FontAwesomeModule,
  ],
})
export class UserTimelinesProfitabilityScoreComponent implements OnInit {
  private store = inject(Store);

  @Input() profitabilityScore: number | null | undefined;
  profitabilityScoreSteps$!: Observable<ProfitabilityScoreSteps>;
  isLoadingUsersRentability = false;

  ngOnInit(): void {
    this.profitabilityScoreSteps$ = this.store.select(
      ProfitabilityScoreState.profitabilityClassification,
    );
  }
}
